import { Action } from '@ngrx/store';


export enum NodeNavigatorActionTypes {
  NAVIGATE_TO_NODE = 'navigate to node',
  NAVIGATE_TO_NODE_WITH_DATA = 'navigate to node with data'
}

export class NavigateToNode implements Action {
  readonly type = NodeNavigatorActionTypes.NAVIGATE_TO_NODE;
  constructor(public payload: { nodeId: string, openPanel?: boolean}) { }
}

export class NavigateToNodeWithData implements Action {
  readonly type = NodeNavigatorActionTypes.NAVIGATE_TO_NODE_WITH_DATA;
  constructor(public payload: { nodeId: string, openPanel?: boolean, data:any}) { }
}

export type NodeNavigatorAction = NavigateToNode| NavigateToNodeWithData;

